import React from 'react';

function H2({ text, className }) {
  return (
    <h2 className={`${className} font-nature-meet-standard tracking-[1px] text-dark-800 md:text-[44px] text-[28px] leading-[1.3] `}>{text}</h2>
  );
}

export default H2;
